export class StoreUserPasswordModel {
    id : string;
    password: string;
}